import React from 'react';
import './WhyChooseSection.css';

const WhyChooseSection = () => {
  const features = [
    {
      icon: '✓',
      title: 'Reliable Platform',
      description: 'Built with enterprise-grade infrastructure for maximum reliability and uptime.'
    },
    {
      icon: '⭐',
      title: 'Proven Results',
      description: 'Trusted by thousands of businesses worldwide to drive growth and efficiency.'
    },
    {
      icon: '🛡️',
      title: 'Secure & Safe',
      description: 'Your data is protected with industry-leading security measures and compliance.'
    }
  ];

  return (
    <section className="why-choose-section">
      <div className="container">
        <h2 className="section-title">Why Choose Our Platform</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-item">
              <div className="feature-icon-large">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;

